import { ChangeEvent, useEffect, useRef } from 'react'

import { SearchFilterForm } from '@/components/forms/filters/search'

interface CompanySearchProps {
  value: string
  autoFocus?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onClear: () => void
}

export function CompanySearch({
  value,
  autoFocus = false,
  onChange,
  onClear,
}: CompanySearchProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!autoFocus) {
      return
    }

    containerRef.current?.querySelector('input')?.focus()
  }, [autoFocus])

  return (
    <div ref={containerRef} className="p-3">
      <SearchFilterForm
        placeholder="companies.search"
        searchValue={value}
        onChange={onChange}
        onClear={onClear}
        className="h-10 min-w-0 shadow-none"
      />
    </div>
  )
}
